export default {
  arrowUpWide: 'i-ph-sort-descending-bold',
  arrowDownWide: 'i-ph-sort-ascending-bold',
  arrowUpDown: 'i-ph-caret-up-down-bold',
  check: 'i-ph-check-bold',
  chevronDown: 'i-ph-caret-down-bold',
  chevronLeft: 'i-ph-caret-left-bold',
  chevronLeftDouble: 'i-ph-caret-double-left-bold',
  chevronRight: 'i-ph-caret-right-bold',
  chevronRightDouble: 'i-ph-caret-double-right-bold',
  clock: 'i-ph-clock-bold',
  close: 'i-ph-x',
  closeBold: 'i-ph-x-bold',
  info: 'i-ph-info-bold',
  loading: 'i-ph-spinner-gap-bold',
  minus: 'i-ph-minus-bold',
  plus: 'i-ph-plus-bold',
  search: 'i-ph-magnifying-glass-bold',
}
